import { Modal, NewButton, NewButtonVariant } from "@visiblethread/react-components";
import Flex, { GAP_CLASS } from "components/Flex";
import { SUBTITLE, TITLE } from "components/TimeInStage/constants";
import OpportunityRow from "components/TimeInStage/OpportunityRow";
import { modalTypes } from "constants/types";
import { arrayOf, number, shape, string } from "prop-types";
import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import {
  exportTimeInStageCsv,
  exportTimeInStagePdf,
} from "slices/timeInStage/actions";

import styles from "./TimeInStageModal.module.scss";

const TimeInStageModal = ({ opportunities }) => {
  const dispatch = useDispatch();
  const isEmpty = opportunities.length === 0;

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.TIME_IN_STAGE));
  };

  const maxDays = useMemo(
    () => Math.max(...opportunities.map((o) => o.daysInStage), 1),
    [opportunities]
  );

  return (
    <Modal
      backdrop
      centered
      className={`fade-in ${styles.modal}`}
      onDismiss={onDismiss}
      show
      size="lg"
    >
      <Modal.Header>{TITLE}</Modal.Header>
      <Modal.Body>
        <div className={styles.timeInStageModal}>
          <p className={styles.timeInStageModal__subHeader}>{SUBTITLE}</p>

          <div className={styles.timeInStageModal__rowsWrapper}>
            <ul
              aria-label="All time in stage opportunities"
              className={styles.timeInStageModal__rows}
            >
              {opportunities.map((opportunity) => (
                <OpportunityRow
                  key={opportunity.opportunityId}
                  maxDays={maxDays}
                  opportunity={opportunity}
                />
              ))}
            </ul>
          </div>
          <Flex justifyContent="flex-end" gap={GAP_CLASS.GAP_200}>
            <NewButton
              disabled={isEmpty}
              onClick={() => dispatch(exportTimeInStageCsv())}
              variant={NewButtonVariant.l2}
            >
              Export CSV
            </NewButton>
            <NewButton
              disabled={isEmpty}
              onClick={() => dispatch(exportTimeInStagePdf())}
              variant={NewButtonVariant.l1}
            >
              Export PDF
            </NewButton>
          </Flex>
        </div>
      </Modal.Body>
    </Modal>
  );
};

TimeInStageModal.propTypes = {
  opportunities: arrayOf(
    shape({
      opportunityId: number.isRequired,
      opportunityName: string.isRequired,
      customerName: string.isRequired,
      stageId: number.isRequired,
      stageName: string.isRequired,
      stageColor: string.isRequired,
      daysInStage: number.isRequired,
      assignees: arrayOf(string).isRequired,
    })
  ).isRequired,
};

export default TimeInStageModal;
